module.exports = __webpack_public_path__ + "static/media/rate-star.7e7da793.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/rate-star.svg
// module id = 883
// module chunks = 0